module.exports = __webpack_public_path__ + "img/bg-1920.14dc9b74.jpg";